import { useFormikContext } from 'formik';
import React, { memo, useState } from 'react';
import { Image } from 'react-bootstrap';
import LabelRequired from '../../../../component/LabelRequired';
import TextField from '../../../../component/TextField';
import ModalLuocDoPTTT from '../ModalLuocDoPTTT';

type Props = {
};

const LuocDoPTTTField = ({ }: Props) => {
	const [openDrawDialog, setOpenDrawDialog] = useState(false);
	const {values, setFieldValue} = useFormikContext<any>();

	return (
		<div>
			<LabelRequired label="Lược đồ PTTT" />
			{values?.formData?.surgerySurgicalProcedureDiagram ? (
				<Image
					src={values?.formData?.surgerySurgicalProcedureDiagram}
					rounded
					width="100%"
					height="200"
					alt="Lược đồ PTTT"
					className="border"
					onClick={() => {
						setOpenDrawDialog(true);
					}}
				/>
			) : (
				<TextField
					disabled={values?.isViewModal}
					as="textarea"
					rows={2}
					className="spaces h-200"
					onClick={() => {
						setOpenDrawDialog(true);
					}}
                    name='surgerySurgicalProcedureDiagram-textarea'
					value=""
				/>
			)}
			{openDrawDialog && (
				<ModalLuocDoPTTT
					open={openDrawDialog}
					onClose={() => {
						setOpenDrawDialog(false);
					}}
					onSave={(data: string) => {
						setFieldValue('formData.surgerySurgicalProcedureDiagram', data);
						setOpenDrawDialog(false);
					}}
					value={values?.formData?.surgerySurgicalProcedureDiagram}
				/>
			)}
		</div>
	);
};

export default LuocDoPTTTField;
